import React, { useContext, useState } from "react";
import { Layout, Input, Badge, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingCartOutlined, SearchOutlined, MenuOutlined, CloseOutlined } from "@ant-design/icons";
import { CartContext } from "../context/CartContext";
import logo from "../Assets/logo.gif";
import "../Styles/UserStylings/Header.css";
import { UserContext } from "../context/UserContext";

const { Header: AntHeader } = Layout;

const Header = () => {
  const { cart } = useContext(CartContext);
  const {user,login} = useContext(UserContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleCartClick = () => {
  if (!user) {
    navigate("/login");
    return;  // stop here
  }
  navigate("/cart");
};


  return (
    <AntHeader className="app-header">
      <div className="header-container">
        {/* Logo */}
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="logo" style={{ width: "200px", marginTop: "-0px", marginLeft:"-15px" ,padding:"2px"}}/>
          </Link>
        </div>

        {/* Hamburger for Mobile */}
        <div className="mobile-menu-icon" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
        </div>

        {/* Desktop & Mobile Navigation */}
        <nav className={`nav-links ${isMenuOpen ? "open" : ""}`}>
          <Link to="/" onClick={() => setIsMenuOpen(false)}>
            <i className="las la-home nav-icon"></i> Home
          </Link>
          <Link to="https://booklocal.co.in/about-us" onClick={() => setIsMenuOpen(false)}>
            <i className="las la-bolt nav-icon"></i> About Us
          </Link>
          <Link to="https://booklocal.co.in/for-users" onClick={() => setIsMenuOpen(false)}>
            <i className="las la-user nav-icon"></i> For Users
          </Link>
          <Link to="https://booklocal.co.in/for-doctors" onClick={() => setIsMenuOpen(false)}>
            <i className="las la-medkit nav-icon"></i> For Doctors
          </Link>
          <Link to="https://booklocal.co.in/doctor-plans" onClick={() => setIsMenuOpen(false)}>
            <i className="las la-file nav-icon"></i> Plans
          </Link>
        {!user && (
  <div className="search-bar-mobile">
    <Button
      style={{ backgroundColor: "#1129ce", color: "white" }}
      onClick={() => navigate("/seller-signup")}
    >
      Register Your Store
    </Button>
  </div>
)}

        </nav>
        <div className="header-right">
          <Badge count={cart.length} className="cart-badge">
            <ShoppingCartOutlined className="cart-icon" onClick={handleCartClick} style={{width:"30px",height:"30px",fontSize:"26px"}} />
          </Badge>
        </div>
      </div>
    </AntHeader>
  );
};

export default Header;
